import { render, staticRenderFns } from "./MoviesFilters.vue?vue&type=template&id=b75a108c&scoped=true&"
import script from "./MoviesFilters.vue?vue&type=script&lang=js&"
export * from "./MoviesFilters.vue?vue&type=script&lang=js&"
import style0 from "./MoviesFilters.vue?vue&type=style&index=0&id=b75a108c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75a108c",
  null
  
)

export default component.exports